import { render, staticRenderFns } from "./UserDataCleansing.modal.vue?vue&type=template&id=8758b594&"
import script from "./UserDataCleansing.modal.vue?vue&type=script&lang=ts&"
export * from "./UserDataCleansing.modal.vue?vue&type=script&lang=ts&"
import style0 from "./UserDataCleansing.modal.vue?vue&type=style&index=0&id=8758b594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports